import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ContractModal from "@/components/modal/ContractModal";
import PolicyModal from "@/components/modal/PolicyModal";

interface FooterProps {
  className?: string;
  logoHref?: string;
  variant?: "default" | "legacy";
}

const Footer = ({ className = "", logoHref = "/", variant = "default" }: FooterProps) => {
  const navigate = useNavigate();
  const [isContractModalOpen, setIsContractModalOpen] = useState(false);
  const [isPolicyModalOpen, setIsPolicyModalOpen] = useState(false);
  if (variant === "legacy") {
    return (
      <footer className={`footerPc container ${className}`}>
        <div className="menuFooter">
          <div className="itemMenuFooter">
            <a
              href={logoHref}
              onClick={(e) => {
                e.preventDefault();
                void navigate(logoHref);
              }}
            >
              <img src="/images/logoLogin.svg" alt="STUDICT" />
            </a>
          </div>
          <div className="itemMenuFooter">
            <ul>
              <li>
                FAQ
                <a
                  href="/support"
                  onClick={(e) => {
                    e.preventDefault();
                    void navigate("/support");
                  }}
                >
                  サポート・FAQ
                </a>
              </li>
              <li>
                <a href="#">特定商取引法</a>
              </li>
              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsContractModalOpen(true);
                  }}
                >
                  利用規約
                </a>
              </li>
              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsPolicyModalOpen(true);
                  }}
                >
                  プライバシーポリシー
                </a>
              </li>
              <li>
                <a href="https://x.com" target="_blank" rel="noopener noreferrer">
                  <img src="/images/twitter.svg" alt="X" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          <p>© 2025 BrightKids Inc. All Rights Reserved.</p>
        </div>
      </footer>
    );
  }

  return (
    <footer className={className}>
      <div className="flex flex-col items-center justify-between gap-6 px-6 text-white lg:flex-row">
        <a
          href={logoHref}
          className="inline-flex"
          onClick={(e) => {
            e.preventDefault();
            void navigate(logoHref);
          }}
        >
          <img src="/images/logoLogin.svg" alt="STUDICT" className="h-10 w-auto" />
        </a>
        <ul className="flex flex-wrap items-center justify-center gap-5 text-xs font-medium text-white lg:justify-end">
          <li>
            <a
              href="/support"
              className="text-white hover:underline"
              onClick={(e) => {
                e.preventDefault();
                void navigate("/support");
              }}
            >
              サポート・FAQ
            </a>
          </li>
          <li>
            <a href="#" className="text-white hover:underline">
              特定商取引法
            </a>
          </li>
          <li>
            <a
              href="#"
              className="text-white hover:underline"
              onClick={(e) => {
                e.preventDefault();
                setIsContractModalOpen(true);
              }}
            >
              利用規約
            </a>
          </li>
          <li>
            <a
              href="#"
              className="text-white hover:underline"
              onClick={(e) => {
                e.preventDefault();
                setIsPolicyModalOpen(true);
              }}
            >
              プライバシーポリシー
            </a>
          </li>
          <li>
            <a
              href="https://x.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex hover:opacity-80"
            >
              <img src="/images/twitter.svg" alt="X" />
            </a>
          </li>
        </ul>
      </div>
      <p className="mt-4 text-center text-[10px] font-light text-white lg:text-right">
        © 2025 BrightKids Inc. All Rights Reserved.
      </p>
      <ContractModal open={isContractModalOpen} onClose={() => setIsContractModalOpen(false)} />
      <PolicyModal open={isPolicyModalOpen} onClose={() => setIsPolicyModalOpen(false)} />
    </footer>
  );
};

export default Footer;
